<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      fullscreenLoading: false,
    };
  },
  mounted() {
    this.openFullScreen2();
  },
  methods: {
    openFullScreen2() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
      }, 300);
    },
  },
};
</script>
<style lang="less">
.el-icon-loading {
  font-size: 40px;
  text-align: center;
}
</style>
